   module.controller('cameraTourCntrl', function($sce, $scope, $mdDialog, isInit, isAudio, isVideo) {
 
    $scope.myInterval = 0;
    $scope.noWrapSlides = false;
    $scope.active = 0;
    var slides = $scope.slides = [];
    var images = Array()
    if(isInit) {
      images.push({id: 0, image: "images/permiso_inicio_1.png"})
      images.push({id: 1, image: "images/permiso_inicio_2.png"}) 
    } else {
      images.push({id: 0, image: "images/permisos_1.png"})
      images.push({id: 1, image: "images/permisos_2.png"})
      images.push({id: 2, image: "images/permisos_3.png"})
      images.push({id: 3, image: "images/permisos_4.png"})
      images.push({id: 4, image: "images/permisos_5.png"})
    } 
     
    $scope.closeDialog = function(){
      $mdDialog.cancel();
    }; 

    $scope.addSlide = function(message) {       
      slides.push(message);
    }; 

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      image.id = i;      
      image.image = (image.image)
      $scope.addSlide(image);
    }
    
    $scope.renderHtml = function (htmlCode) {
      return $sce.trustAsHtml(htmlCode);
    };
    
    $scope.showNext = true;
    if($scope.slides.length == 1) {
      $scope.showNext = false;
    }     
    $scope.showPrev = false;
    $scope.nextSlide = function() {   
      $scope.goNext();
    }

    $scope.prevSlide = function() {      
      $scope.goPrev();
    }
    $scope.lastSlide = function() {     
      $mdDialog.hide();
    }
    
    $scope.$watch('active', function(newIndex, oldIndex) {
      if (Number.isFinite(newIndex) && newIndex!==oldIndex) {        
         $scope.showNext = newIndex != $scope.slides.length - 1; 
         $scope.showPrev = newIndex != 0; 
      }
  });
    
    });
    